import React, { useState, useEffect, useRef } from "react";
import { filter, map } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { performLogout, updateUserData, updateUserWalletBalance, updateUserSpecialRollover, updateUserRolloverBalance } from "../../redux/AuthAction.js";
import { setDisplayLiveChat, setDisplayLogin, setDisplayRegister, setIsShowCreateShareHolderPin, setIsShowVerifyShareHolderPin, setIsShowBigWinning, checkMemberDownlineDeposit } from "../../redux/AppAction.js";
import { useTranslation } from "react-i18next";
import SecureLS from "secure-ls";
import ApiEngine from "./../../util/ApiEngine.js";
import {
    Spinner
} from "reactstrap";
import {
    LanguageOption,
    ApiUrl,
    ApiKey,
    SessionKey,
    WebUrl,
    DisplayDevice,
    Language,
    AlertTypes,
    _MAIN_WALLET_ID,
    getHostnameReferralCode
} from "./../../util/Constant.js";
import {
    setBusy,
    setIdle,
    showResponseMessage,
    setIsShareholder,
    setIsCreateShareHolderPin,
    setCommunicationChannelList,
    showMessage,
    setIsNonSeamlessGameExist,
    setRtpUrl,
    setProductCategoryGameList,
    setUnclaimCommission,
    setGrandTotalRewards,
    setGamePoints,
    setUnreadNotification,
    setIsShowCreateShareHolderPinPopup,
    handleTelegramBannerOnClick,
    setTelegramBotStatus
} from "../../redux/AppAction.js";
import {
    createFormBody,
    createMultiPartFormBody,
    numberWithCurrencyFormat,
    stringIsNullOrEmpty,
    numberWithCurrencyFormat2
} from "./../../util/Util.js";
import { Link, useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { saveLanguageId } from "../../redux/LanguageAction.js";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Auth from "../../components/auth/Auth.js"
import DownloadFloatingComponent from "../../components/custom/DownloadFloatingComponent.js"
import ContactUsFloatingComponent from "../../components/custom/ContactUsFloatingComponent.js"
import ShareHolderAuth from "../../components/auth/ShareHolderAuth.js"
import GifFloatingComponent from "../../components/custom/GifFloatingComponent.js"
import { LiveChatWidget, useWidgetState } from '@livechat/widget-react';
import NonSeamlessGameWalletModal from "../wallet/NonSeamlessGameWalletModal";
import { setPlayableCategory, setProductCategory, setRolloverTarget, setGameProviders } from "../../redux/GameAction.js";
import { startGame } from "../../redux/GameAction.js";
import CustomMiniGames from '../../components/custom/CustomMiniGames';
import BigWinningModal from '../../components/big-winning/BigWinningModal.js';
import WorldCupParlay from "../custom/WorldCupParlay.js";

const defaultImage = "/img/Coming Soon.png";

const Header = ({ className }) => {
    const { t, i18n } = useTranslation();
    const _dispatch = useDispatch();
    const _history = useHistory();
    const widgetState = useWidgetState();

    const _ALERT_TIMEOUT = 3000;
    let isShowLiveChat = useSelector((state) => state.appState.isShowLiveChat);
    let isNonSeamlessGameExist = useSelector((state) => state.appState.isNonSeamlessGameExist);
    let unclaimCommission = useSelector((state) => state.appState.unclaimCommission);
    let grandTotalRewards = useSelector((state) => state.appState.grandTotalRewards);
    let gamePoints = useSelector((state) => state.appState.gamePoints);
    var _userData = useSelector((state) => state.authState.userData);
    let isPlatinum = useSelector((state) => state.appState.isPlatinum);
    let telegramBotStatus = useSelector((state) => state.appState.telegramBotStatus);
    const [fifaStatus, setFifaStatus] = useState(false);
    const { productCategory, rolloverTarget, playableCategory } = useSelector((state) => state.gameState);
    /* language */
    const [selectedLanguage, setSelectedLanguage] = useState("ID");

    /*  display date time*/
    const location = useLocation();
    const [displayDateTime, setDisplayDateTime] = useState(
        moment().format("YYYY-MM-DD HH:mm:ss Z")
    );

    /* social media */
    const [showMediaList, setShowMediaList] = useState(false);
    const socialMediaList = [
        {
            image: "/img/ug/header/social-media-icon/facebook.svg",
            alt: "i8 facebook",
            url: "https://www.facebook.com/i8OfficialTeam",
            class: "facebook"
        },
        {
            image: "/img/ug/header/social-media-icon/youtube.svg",
            alt: "i8 youtube",
            url: "https://www.youtube.com/channel/UCxrKFaJx8jENt4hjrnKtYiQ",
            class: "youtube"
        },
        {
            image: "/img/ug/header/social-media-icon/instagram.svg",
            alt: "i8 instagram",
            url: "https://instagram.com/i8.live",
            class: "instagram"
        },

    ]


    /*  lang dropdown */
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const countryList = [
        {
            name: "Indonesia",
            iso: "ID",
            icon: "/img/v3/id.svg",
            icon_circle: "/img/v3/id-circle.svg",
            url: window.location.origin,//(window.location.href).includes("staging") ? 'https://id-staging.huat8id.com/' : (window.location.href).includes("preproduction") ? 'https://id-preproduction.huat8id.com/' : 'https://i8id.live/',
            child_languages: [
                {
                    name: "Indo",
                    languageCode: Language._INDON,
                    languageId: 7
                },
                {
                    name: "English",
                    languageCode: Language._ENGLISH,
                    languageId: 1
                },
            ],
        },
        {
            name: "Malaysia",
            iso: "MYR",
            icon: "/img/v3/my.svg",
            icon_circle: "/img/v3/my-circle.svg",
            url: (window.location.href).includes("staging") ? 'https://my-staging-d.huat8my.com/' : (window.location.href).includes("preproduction") ? 'https://my-preproduction-d.huat8my.com/' : 'https://i8my.live/',
            child_languages: [
                {
                    name: "English",
                    languageCode: Language._ENGLISH,
                    languageId: 1
                },
                {
                    name: "中文",
                    languageCode: Language._CHINESE,
                    languageId: 2
                },
                {
                    name: "Malay",
                    languageCode: Language._BAHASA_MELAYU,
                    languageId: 3
                },
                {
                    name: "ไทย",
                    languageCode: Language._THAI,
                    languageId: 5
                },
                {
                    name: "Tiếng Việt",
                    languageCode: Language._VIETNAMESE,
                    languageId: 6
                },
                {
                    name: "Indo",
                    languageCode: Language._INDON,
                    languageId: 7
                }
            ],
        },
        {
            name: "Thailand",
            iso: "TH",
            icon: "/img/v3/th.svg",
            icon_circle: "/img/v3/th-circle.svg",
            url: (window.location.href).includes("staging") ? 'https://th-staging-d.huat8th.com' : (window.location.href).includes("preproduction") ? 'https://th-preproduction-d.huat8th.com' : 'https://i8th.live',
            child_languages: [
                {
                    name: "ไทย",
                    languageCode: Language._THAI,
                    languageId: 5
                },
                {
                    name: "English",
                    languageCode: Language._ENGLISH,
                    languageId: 1
                },
                {
                    name: "中文",
                    languageCode: Language._CHINESE,
                    languageId: 2
                },
                {
                    name: "Malay",
                    languageCode: Language._BAHASA_MELAYU,
                    languageId: 3
                },
                {
                    name: "Tiếng Việt",
                    languageCode: Language._VIETNAMESE,
                    languageId: 6
                },
                {
                    name: "Indo",
                    languageCode: Language._INDON,
                    languageId: 7
                }
            ],
        },
        //{
        //    name: "Australia",
        //    iso: "AU",
        //    icon: "/img/v3/aud.svg",
        //    icon_circle: "/img/v3/aud-circle.svg",
        //    url: (window.location.href).includes("staging") ? 'https://au-staging-d.huat8au.com' : (window.location.href).includes("preproduction") ? 'https://au-preproduction-d.huat8au.com' : 'https://i8au.live',
        //    child_languages: [
        //        {
        //            name: "English",
        //            languageCode: Language._ENGLISH,
        //            languageId: 1
        //        },
        //        {
        //            name: "中文",
        //            languageCode: Language._CHINESE,
        //            languageId: 2
        //        },
        //        {
        //            name: "Malay",
        //            languageCode: Language._BAHASA_MELAYU,
        //            languageId: 3
        //        },
        //        {
        //            name: "ไทย",
        //            languageCode: Language._THAI,
        //            languageId: 5
        //        },
        //        {
        //            name: "Tiếng Việt",
        //            languageCode: Language._VIETNAMESE,
        //            languageId: 6
        //        },
        //        {
        //            name: "Indo",
        //            languageCode: Language._INDON,
        //            languageId: 7
        //        }
        //    ],
        //},
    ];

    /* official link dropdown */
    const [showOfficialLinkDropdown, setShowOfficialLinkDropdown] = useState(false);
    const [companyOfficialLinks, setCompanyOfficialLinks] = useState([]);
    const [displayOfficialLinks, setDisplayOfficialLinks] = useState([]);

    /* item list*/
    const [isWalletDropdownOpen, setIsWalletDropdownOpen] = useState(false);
    const [isTransactionDropdownOpen, setIsTransactionDropdownOpen] = useState(false);
    const [isVIPDropdownOpen, setIsVIPDropdownOpen] = useState(false);
    const [providerList, setProviderList] = useState([]);
    const [walletDropdownOptions, setWalletDropdownOptions] = useState({});
    const ProductCategoryGameList = useSelector((state) => state.appState.productCategoryGameList);
    const [mergedCategoryList, setMergedCategoryList] = useState([]);
    const [catIndexClicked, setCatIndexClicked] = useState(-1);
    const [seletedProvider, setSeletedProvider] = useState(false);
    //VIP
    const [isGoldHover, setIsGoldHover] = useState(false);
    const [isPlatinumHover, setIsPlatinumHover] = useState(false);
    const [isPartnerHover, setIsPartnerHover] = useState(false);


    const transactionDropdownOptions = [
        {
            title: t("DEPOSIT"),
            image: "/img/ug/header/nav-icon/deposit-ug-2.svg",
            url: WebUrl._URL_DEPOSIT,
            isDisplay: true,
        },
        {
            title: t("WITHDRAWAL"),
            image: "/img/ug/header/nav-icon/withdraw-ug.svg",
            url: WebUrl._URL_WITHDRAWAL,
            isDisplay: _userData && _userData.isBlockWithdraw ? false : true,
        },
        //{
        //  title: t("TRANSFER"),
        //  image: "/img/ug/header/nav-icon/transfer-ug.svg",
        //  url: WebUrl._URL_TRANSFER,
        //  isDisplay: isNonSeamlessGameExist,
        //},
        {
            title: t("STATEMENT"),
            image: "/img/ug/header/nav-icon/statement-ug.svg",
            url: WebUrl._URL_STATEMENT,
            isDisplay: true,
        }
    ]


    /* info list*/
    const [showInfoList, setShowInfoList] = useState(false);


    /* game category list */
    const [isGameDropdownVisible, setIsGameDropdownVisible] = useState(false);
    const [isTxnDropdownVisible, setIsTxnDropdownVisible] = useState(false);
    const [isSearchInputVisible, setIsSearchInputVisible] = useState(false);

    const rtpUrl = useSelector((state) => state.appState.rtpUrl);

    var { isLoggedIn } = useSelector((state) => state.authState);
    let unreadNotification = useSelector((state) => state.appState.unreadNotification);
    const [firstLoad, setFirstLoad] = useState(true);


    const search = window.location.search;
    const params = new URLSearchParams(search);

    const [selectedLanguageCode, setSelectedLanguageCode] = useState("id");

    const _SECONDS_IN_MS = 1000;

    const headerDropdown = useRef(null);
    const headerTxnDropdown = useRef(null);
    const headerSearchBar = useRef(null);
    const notificationInterval = useRef(null);
    const specialRolloverInterval = useRef(null);


    useEffect(() => {
        getDesktopGeneralData();
        if (params.get("languageCode") != null) {
            onChangeLanguage(params.get("languageCode"));
            localStorage.setItem(SessionKey._LANGUAGE, params.get("languageCode"));
        }
        else if (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined') {
            if (LanguageOption.find(
                (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)) != undefined) {
                setSelectedLanguage(
                    LanguageOption.find(
                        (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)
                    ).prefix
                );
                setSelectedLanguageCode(
                    LanguageOption.find(
                        (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)
                    ).code
                );

                i18n.changeLanguage(localStorage.getItem(SessionKey._LANGUAGE));
            }
            else {
                i18n.changeLanguage("ID");
                setSelectedLanguage("ID");
                setSelectedLanguageCode("ID");
                localStorage.setItem(SessionKey._LANGUAGE, "id");
            }
        } else {
            i18n.changeLanguage("ID");
            setSelectedLanguage("ID");
            setSelectedLanguageCode("ID");
            localStorage.setItem(SessionKey._LANGUAGE, "id");
        }
    }, [(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
        localStorage.getItem(SessionKey._LANGUAGE) : 'id')]);

    /* display date time*/
    useEffect(() => {
        setTimeout(() => {
            setDisplayDateTime(moment().format("YYYY-MM-DD HH:mm:ss Z"));
        }, _SECONDS_IN_MS);
    }, [displayDateTime]);

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (
                isGameDropdownVisible &&
                headerDropdown.current &&
                !headerDropdown.current.contains(e.target)
            ) {
                setIsGameDropdownVisible(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [isGameDropdownVisible]);

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (
                isTxnDropdownVisible &&
                headerTxnDropdown.current &&
                !headerTxnDropdown.current.contains(e.target)
            ) {
                setIsTxnDropdownVisible(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [isTxnDropdownVisible]);

    useEffect(() => {
        const checkIfClickedOutsideSearch = (e) => {
            if (
                isSearchInputVisible &&
                headerSearchBar.current &&
                !headerSearchBar.current.contains(e.target)
                // ||
                // (headerSearchResult.current &&
                //   !headerSearchResult.current.contains(e.target))
            ) {
                setIsSearchInputVisible(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutsideSearch);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutsideSearch);
        };
    }, [isSearchInputVisible]);

    useEffect(() => {
        if (!firstLoad) {
            getDesktopAuthData();
            if (isLoggedIn) {
                getRewardData();
                getUnclaimCommHistory();
                _dispatch(checkMemberDownlineDeposit());
                clearInterval(notificationInterval.current);
                notificationInterval.current = setInterval(getUnreadNotification, 5000);
            } else {
                clearInterval(notificationInterval.current);
                clearInterval(specialRolloverInterval.current);
                _dispatch(setPlayableCategory([]));
                _dispatch(setRolloverTarget(0));
            }
        }

        if (isLoggedIn) {
            getWorldCupStatus();
            if (_userData.isShareHolder && _userData.isCreateShareHolderPin) {
                _dispatch(setIsShowCreateShareHolderPinPopup(true));
            }
            if (!_userData.seeHiddenGames) {
                let tempCompanyOfficialLinks = companyOfficialLinks.filter(x => !x.testing);
                setDisplayOfficialLinks(tempCompanyOfficialLinks);
            }
            else {
                setDisplayOfficialLinks(companyOfficialLinks);
            }
        }
        else {
          let tempCompanyOfficialLinks = companyOfficialLinks.filter(x => !x.testing);
          setDisplayOfficialLinks(tempCompanyOfficialLinks);
        }

        return () => {
            clearInterval(specialRolloverInterval.current);
            clearInterval(notificationInterval.current);
        };
    }, [isLoggedIn]);

    useEffect(() => {
        if (isLoggedIn && _userData && _userData.isSpecialRollover && productCategory.length > 0) {
            getRolloverData();
            getBonusDepositProductCategory();
            clearInterval(specialRolloverInterval.current);
            specialRolloverInterval.current = setInterval(getMemberSpecialRollover, 5000);
        } else {
            clearInterval(specialRolloverInterval.current);
        }
    }, [_userData.isSpecialRollover])

    useEffect(() => {
        if (isLoggedIn && _userData && _userData.rolloverBalance === 0) {
            _dispatch(setRolloverTarget(0));
        }
    }, [_userData.rolloverBalance])

    useEffect(() => {
        setMergedCategoryList(ProductCategoryGameList.concat(categoryList));
    }, [ProductCategoryGameList]);

    useEffect(() => {
        if (widgetState) {
            if (widgetState.visibility === "minimized") {
                _dispatch(setDisplayLiveChat(false));
            }
        }
    }, [widgetState])

    useEffect(() => {
        if (!firstLoad) {
            getDesktopLanguageData();
            if (isLoggedIn) {
                clearInterval(notificationInterval.current);
                notificationInterval.current = setInterval(getUnreadNotification, 5000);
            } else {
                clearInterval(notificationInterval.current);
            }
        }
        return () => clearInterval(notificationInterval.current);
    }, [i18n.language]);

    useEffect(() => {
        const walletDropdownOptions1 = [
            {
                title: t("COMMISSION"),
                image: "/img/ug/header/nav-icon/commission.svg",
                url: WebUrl._URL_UNCLAIM_COMMISSION_HISTORY,
                value: numberWithCurrencyFormat(parseFloat(unclaimCommission), 3, true)
            },
            {
                title: t("REWARDS"),
                image: "/img/ug/header/nav-icon/rewards.svg",
                url: WebUrl._URL_REWARDS,
                value: numberWithCurrencyFormat(parseFloat(grandTotalRewards), 3, true)
            },
            {
                title: t("GAME_POINTS"),
                image: "/img/ug/header/nav-icon/game-points.svg",
                url: WebUrl._URL_LOYALTY_REDEMPTION,
                value: numberWithCurrencyFormat(parseFloat(gamePoints), 3, true)
            }
        ]
        setWalletDropdownOptions(walletDropdownOptions1);
    }, [unclaimCommission, grandTotalRewards, gamePoints]);

    const getDesktopGeneralData = async () => {
        _dispatch(setBusy());
        let responseJson = await ApiEngine.get(ApiUrl._API_UG_GET_DESKTOP_HEADER_GENERAL_DATA + "?languageCode=" +
            (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let originalData = responseJson[ApiKey._API_DATA_KEY];
            let data = originalData['activeProductCategory']
            let tempArray = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].originalTitle === "SlotMix" || data[i].originalTitle === "Slots") {
                    let hasSlots = tempArray.filter(x => x.originalTitle === "Slots").length > 0;
                    if (!hasSlots) {
                        data[i].icon = "/img/ug/header/game-category-icon/slots-ug.svg";
                        data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", "Slots").replace(":provider?", "");
                        tempArray.push(data[i]);
                    }
                } else {
                    data[i].icon = "/img/ug/header/game-category-icon/" + data[i].originalTitle.toLowerCase().replace(/\s/g, '') + "-ug.svg";
                    data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", data[i].originalTitle).replace(":provider?", "");
                    tempArray.push(data[i]);
                }
            }
            _dispatch(setProductCategoryGameList(tempArray));
            _dispatch(setRtpUrl(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                originalData['rtpUrl'] + "?lang=" + localStorage.getItem(SessionKey._LANGUAGE) : originalData['rtpUrl'] + "?lang=id"));
            _dispatch(setCommunicationChannelList(originalData['channels']));
            _dispatch(setIsNonSeamlessGameExist(originalData['isNonSeamlessMasterProduct']));
            _dispatch(setTelegramBotStatus(originalData['telegramBotStatus']));

            let tempArray2 = [];
            let data2 = originalData['productCategories'];
            data2.forEach(x => {
                if (x.id > 0) {
                    tempArray2.push({ value: x.id.toString(), label: x.title });
                }
            });
            _dispatch(setProductCategory(tempArray2));
            setProviderList(originalData['masterProducts']);
            setCompanyOfficialLinks(originalData["officialLinks"]);
            setDisplayOfficialLinks(originalData["officialLinks"].filter(x => isLoggedIn ? true : !x.testing));
            setFirstLoad(false);
        } else {
            _dispatch(
                showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
            );

        }
        _dispatch(setIdle());
    }

    const getDesktopAuthData = async () => {
        _dispatch(setBusy());
        let responseJson = await ApiEngine.get(ApiUrl._API_UG_GET_DESKTOP_HEADER_AUTH_DATA + "?languageCode=" +
            (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let originalData = responseJson[ApiKey._API_DATA_KEY];
            let data = originalData['activeProductCategory']
            let tempArray = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].originalTitle === "SlotMix" || data[i].originalTitle === "Slots") {
                    let hasSlots = tempArray.filter(x => x.originalTitle === "Slots").length > 0;
                    if (!hasSlots) {
                        data[i].icon = "/img/ug/header/game-category-icon/slots-ug.svg";
                        data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", "Slots").replace(":provider?", "");
                        tempArray.push(data[i]);
                    }
                } else {
                    data[i].icon = "/img/ug/header/game-category-icon/" + data[i].originalTitle.toLowerCase().replace(/\s/g, '') + "-ug.svg";
                    data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", data[i].originalTitle).replace(":provider?", "");
                    tempArray.push(data[i]);
                }
            }
            _dispatch(setProductCategoryGameList(tempArray));
            _dispatch(setIsNonSeamlessGameExist(originalData['isNonSeamlessMasterProduct']));


            let tempArray2 = [];
            let data2 = originalData['productCategories'];
            data2.forEach(x => {
                if (x.id > 0) {
                    tempArray2.push({ value: x.id.toString(), label: x.title });
                }
            });
            _dispatch(setProductCategory(tempArray2));
            _dispatch(setGameProviders(originalData['masterProducts']));
            setProviderList(originalData['masterProducts']);
            setFirstLoad(false);
        } else {
            _dispatch(
                showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
            );

        }
        _dispatch(setIdle());
    }

    const getDesktopLanguageData = async () => {
        _dispatch(setBusy());
        let responseJson = await ApiEngine.get(ApiUrl._API_UG_GET_DESKTOP_HEADER_LANGUAGE_DATA + "?languageCode=" +
            (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let originalData = responseJson[ApiKey._API_DATA_KEY];
            let data = originalData['activeProductCategory']
            let tempArray = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].originalTitle === "SlotMix" || data[i].originalTitle === "Slots") {
                    let hasSlots = tempArray.filter(x => x.originalTitle === "Slots").length > 0;
                    if (!hasSlots) {
                        data[i].icon = "/img/ug/header/game-category-icon/slots-ug.svg";
                        data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", "Slots").replace(":provider?", "");
                        tempArray.push(data[i]);
                    }
                } else {
                    data[i].icon = "/img/ug/header/game-category-icon/" + data[i].originalTitle.toLowerCase().replace(/\s/g, '') + "-ug.svg";
                    data[i].url = WebUrl._URL_PROVIDER_LOBBY.replace(":category", data[i].originalTitle).replace(":provider?", "");
                    tempArray.push(data[i]);
                }
            }
            _dispatch(setProductCategoryGameList(tempArray));
            _dispatch(setRtpUrl(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                originalData['rtpUrl'] + "?lang=" + localStorage.getItem(SessionKey._LANGUAGE) : originalData['rtpUrl'] + "?lang=id"));


            let tempArray2 = [];
            let data2 = originalData['productCategories'];
            data2.forEach(x => {
                if (x.id > 0) {
                    tempArray2.push({ value: x.id.toString(), label: x.title });
                }
            });
            _dispatch(setProductCategory(tempArray2));
            //setProviderList(originalData['masterProducts']);
            setFirstLoad(false);
        } else {
            _dispatch(
                showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
            );

        }
        _dispatch(setIdle());
    }

    const getRTPUrl = async () => {
        let rtpurl = await ApiEngine.get(ApiUrl._API_GET_RTP_URL);
        if (rtpurl[ApiKey._API_SUCCESS_KEY] && rtpurl[ApiKey._API_DATA_KEY] !== null) {
            _dispatch(setRtpUrl(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                rtpurl[ApiKey._API_DATA_KEY] + "?lang=" + localStorage.getItem(SessionKey._LANGUAGE) : rtpurl[ApiKey._API_DATA_KEY] + "?lang=id"));
        }
    }

    const getRolloverData = async () => {
        var responseJson = await ApiEngine.get(ApiUrl._API_GET_ROLLOVER_RECORD);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let data = responseJson[ApiKey._API_DATA_KEY];
            if (data.length > 0) {
                _dispatch(setRolloverTarget(data[0].rolloverTarget));
            } else {
                _dispatch(setRolloverTarget(0));
            }
        }
    }

    const onChangeLanguage = async (selectedLanguage) => {
        _dispatch(setBusy());
        setSelectedLanguage(
            LanguageOption.find((x) => x.code === selectedLanguage).prefix
        );
        i18n.changeLanguage(selectedLanguage);
        if (!isLoggedIn) {
            _dispatch(saveLanguageId(selectedLanguage, true));
        } else {
            _dispatch(saveLanguageId(selectedLanguage));
            let data = {};
            // data["id"] = _userData.userId;
            // data["selectedTheme"] = _userData.selectedTheme;
            data["languageSetting"] = selectedLanguage;
            // data["isMemberOperate"] = true;

            // Silently update user's language settings
            await ApiEngine.post(
                // ApiUrl._API_CREATE_OR_UPDATE_MEMBER,
                ApiUrl._API_UPDATE_MEMBER_LANGUAGE,
                createMultiPartFormBody(data)
            );

            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                        action: "language",
                        language: selectedLanguage,
                    })
                );
            }
        }
        _dispatch(setIdle());
    };

    const updateMemberWalletBalance = async () => {
        let walletResponse = await ApiEngine.get(ApiUrl._API_GET_MEMBER_WALLET_BALANCE);
        if (walletResponse[ApiKey._API_SUCCESS_KEY]) {
            let data = walletResponse[ApiKey._API_DATA_KEY];
            _dispatch(updateUserWalletBalance(data));
        }
    }

    const handleCountryOnClick = async (countryItem, selectedLanguage) => {
        if (window.location.href.startsWith(countryItem.url) || (window.location.href.includes("localhost") && countryItem.iso == "ID")) {
            if (typeof (selectedLanguage) !== "undefined") {
                onChangeLanguage(selectedLanguage);
            }
        }
        else {
            let redirectUrl = countryItem.url + "?languageCode=" + (typeof (selectedLanguage) !== "undefined" ? selectedLanguage : "id");
            window.location.assign(redirectUrl);
        }
        setShowLanguageDropdown(false);
    }

    // get member special roll over
    const getMemberSpecialRollover = async () => {
        let responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_IS_SPECIAL_ROLLOVER_DATA);
        let data = "";

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            data = responseJson[ApiKey._API_DATA_KEY];
            _dispatch(updateUserSpecialRollover(data['isSpecialRollover']));
            _dispatch(updateUserRolloverBalance(data['rollOverBalance']));
        }
    }

    //get playdable category
    const getBonusDepositProductCategory = async () => {
        let responseJson = await ApiEngine.get(ApiUrl._API_GET_BONUS_DEPOSIT_PRODUCT_CATEGORY);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let data = responseJson[ApiKey._API_DATA_KEY];
            let productCategoryArr = [];

            if (data.includes(",")) {
                productCategoryArr = responseJson[ApiKey._API_DATA_KEY].split(",");
            }
            else {
                productCategoryArr.push(data);
            }

            let tempArr = [];
            productCategory.forEach((x) => {
                if (productCategoryArr.includes(x.value)) {
                    tempArr.push(x.label);
                }
            })
            _dispatch(setPlayableCategory(tempArr));
        }
    }

    //update big winning view history count

    const updateMemberBigWinningViewHistoryCount = async () => {
        await ApiEngine.get(ApiUrl._API_UPDATE_MEMBER_BIG_WINNING_VIEW_HISTORY_COUNT);
    }

    const categoryList = [

        {
            icon: "/img/ug/header/game-category-icon/promotion.svg",
            title: t("PROMOTION"),
            originalTitle: null,
            isHot: false,
            isNew: false,
            url: WebUrl._URL_PROMOTION,
            requiredAuth: false,
            openNewWindow: false,
            onActivePage: false,
            isActive: true
        },
        {
            icon: "/img/ug/header/game-category-icon/affiliate.svg",
            title: t("AFFILIATE"),
            originalTitle: null,
            isHot: false,
            isNew: false,
            url: WebUrl._URL_AFFILIATE_PARTNER_PROGRAM,
            requiredAuth: false,
            openNewWindow: false,
            onActivePage: false,
            isActive: true
        },
        //{
        //    icon: "/img/ug/header/game-category-icon/rtp-live.svg",
        //    title: t("RTP LIVE"),
        //    originalTitle: null,
        //    isHot: false,
        //    isNew: false,
        //    url: rtpUrl,
        //    requiredAuth: false,
        //    openNewWindow: true,
        //    onActivePage: false,
        //    isActive: true
        //},
        {
            icon: "/img/ug/header/game-category-icon/daily-check-in.svg",
            title: t("DAILY_CHECK_IN"),
            originalTitle: null,
            isHot: false,
            isNew: false,
            url: WebUrl._URL_DAILY_CHECK_IN,
            requiredAuth: false,
            openNewWindow: false,
            onActivePage: false,
            isActive: true
        }
    ];


    //get unclaim comm hisyory
    const getUnclaimCommHistory = async () => {
        _dispatch(setUnclaimCommission());
    };

    //get reward data
    const getRewardData = async () => {
        let responseJson = await ApiEngine.get(
            ApiUrl._API_GET_CATEGORY_REWARD_RATES + "?all=true"
        );

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let data = responseJson[ApiKey._API_DATA_KEY];
            let tempObj = {};
            let grandTotalReward = 0;
            let categoryTotal = {};
            data.map((rewardData, index) => {
                if (!tempObj[rewardData["date"]]) {
                    tempObj[rewardData["date"]] = { totalAmount: 0, totalAmountClaimable: 0 };
                }
                if (!tempObj[rewardData["date"]][rewardData["categoryTitle"]]) {
                    tempObj[rewardData["date"]][rewardData["categoryTitle"]] = { totalAmount: 0, totalAmountClaimable: 0 };
                }
                if (!tempObj[rewardData["date"]][rewardData["categoryTitle"]][rewardData["providerName"]]) {
                    tempObj[rewardData["date"]][rewardData["categoryTitle"]][rewardData["providerName"]] = { productImage: rewardData["productImage"], rate: rewardData["rewardRate"] };
                }
                tempObj[rewardData["date"]].totalAmount += rewardData["amount"];
                tempObj[rewardData["date"]][rewardData["categoryTitle"]].totalAmount += rewardData["amount"];
                if (rewardData["claimed"] !== "True") {
                    tempObj[rewardData["date"]].totalAmountClaimable += rewardData["amount"];
                    tempObj[rewardData["date"]][rewardData["categoryTitle"]].totalAmountClaimable += rewardData["amount"];
                    grandTotalReward += rewardData["amount"];

                    if (!categoryTotal[rewardData["categoryTitle"]]) {
                        categoryTotal[rewardData["categoryTitle"]] =
                        {
                            category: rewardData["categoryTitle"],
                            totalAmount: rewardData["amount"]
                        };
                    }
                    else if (categoryTotal[rewardData["categoryTitle"]]) {
                        categoryTotal[rewardData["categoryTitle"]].totalAmount += rewardData["amount"];
                    }
                    else if (categoryTotal[rewardData["categoryTitle"]]) {
                        categoryTotal[rewardData["categoryTitle"]] =
                        {
                            category: rewardData["categoryTitle"],
                            totalAmount: rewardData["amount"]
                        };
                    }
                }

            });
            _dispatch(setGrandTotalRewards(grandTotalReward));
        } else {
            _dispatch(
                showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
            );
        }
    }


    //get notification

    const getUnreadNotification = async () => {
        try {
            clearInterval(notificationInterval.current);
            var responseJson = await ApiEngine.get(
                ApiUrl._API_GET_UNREAD_NOTIFICATION_LIST + "?languageCode=" +
                (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
                    localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

            if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                _dispatch(setUnreadNotification(responseJson[ApiKey._API_DATA_KEY]));
            } else {
                _dispatch(setUnreadNotification(0));
            }
        } catch (error) {
            clearInterval(notificationInterval.current);
        } finally {
            if (isLoggedIn) {
                notificationInterval.current = setTimeout(getUnreadNotification, 30000); // Adjust interval time as needed
            }
        }
    }

    // handle route url
    const handleHeaderRoute = async (url, openNewWindow) => {
        if (openNewWindow) {
            window.open(url, "_blank");
        } else {
            _history.push(url)
        }
    }

    const beforeEnterVipPage = async () => {
        if (location.pathname !== WebUrl._URL_VIP) {
            if (_userData.isCreateShareHolderPin) {
                _dispatch(setIsShowCreateShareHolderPin(true));
                _dispatch(setIsShowVerifyShareHolderPin(false));
            } else {
                _dispatch(setIsShowCreateShareHolderPin(false));
                _dispatch(setIsShowVerifyShareHolderPin(true));
            }
        }
    }

    // handle provider click
    async function handleProviderClick(provider) {
        if (provider.productGame != null && provider.productGame["gameCode"] === 'MEGATOGEL' && moment(provider.productGame["parameter_1"]).isValid() && moment(provider.productGame["parameter_1"]).isAfter(moment())) {
            _dispatch(
                showMessage({
                    type: AlertTypes._INFO,
                    content: t("COMING_SOON"),
                })
            );
        } else {
            if (isLoggedIn) {
                if (provider.hasOwnLobby) {
                    handleHasLobbyGameList(provider.name, provider.category);
                } else {
                    if (provider.productGame != null && provider.isUM !== true) {
                        _dispatch(startGame(provider.productGame));
                    } else {
                        _dispatch(
                            showMessage({
                                type: AlertTypes._INFO,
                                content: t("GAME_UM"),
                                onConfirm: () => {
                                    //console.log("hi");
                                },
                            })
                        );
                    }
                }

            }
            else {
                if (provider.hasOwnLobby) {
                    handleHasLobbyGameList(provider.name, provider.category);
                } else {
                    _dispatch(
                        setDisplayLogin(true)
                    );
                }
            }
        }

    }

    // retrieve product game list by provider name
    const handleHasLobbyGameList = (productName, category) => {
        setSeletedProvider(true);
        const url = WebUrl._URL_PROVIDER_LOBBY
            .replace(":category", category)
            .replace("/:provider?", productName ? "/" + productName : "");
        _history.push(url)
    }

    const handleHeaderCatOnClick = (catIndex) => {
        setCatIndexClicked(catIndex);
        setTimeout(() => {
            setCatIndexClicked(-1);
            setSeletedProvider(false);
        }
            , 1000);
    }

    // Import all images in the folder
    //const images = require.context('../../../public/img/ug/header/game-providers', false, /\.(png|jpe?g|svg)$/);

    //// Convert them to a map for easy lookup
    //const imageMap = images.keys().reduce((acc, path) => {
    //    const key = path.replace('./', '').replace(/\.(png|jpe?g|svg)$/, '');
    //    acc[key] = images(path);
    //    return acc;
    //}, {});

  const getWorldCupStatus = async () => {
    _dispatch(setBusy());
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_WORLD_CUP_STATUS
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      console.log("fifaStatus", data)
      setFifaStatus(data);

    }
    _dispatch(setIdle());
  }

    return (
        <>
            <div id="header-wrapper" className={className}>
                <div>
                    <header className="login">
                        <div className="header-container">
                            <div className="header-top">
                                <div className="first">
                                    <LazyLoadImage
                                        src={"/img/ug/header/nav-icon/i8.live_2026.png"}
                                        className="img-responsive"
                                        alt="i8 logo"
                                        onClick={() => _history.push(WebUrl._URL_MAIN)}
                                    />
                                </div>
                                <div className="second">
                                    <div className="header-top-first">
                                        <div>
                                            {displayDateTime}
                                        </div>
                                        <div className="header-social-media-container">
                                            {showMediaList && socialMediaList &&
                                                socialMediaList.length > 0 &&
                                                map(socialMediaList, (item, index) => {
                                                    return (
                                                        <div key={index} className={`header-social-media-items ${item.class} ${showMediaList ? 'push-out' : ''}`} onClick={() => window.open(item.url)} >
                                                            <LazyLoadImage
                                                                src={item.image}
                                                                className='img-responsive'
                                                                alt={item.alt}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            <div className="header-social-media-items" onClick={() => { setShowMediaList(!showMediaList) }}>
                                                {showMediaList ?
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/social-media-icon/close.svg"}
                                                        className='img-responsive'
                                                        alt="close media icon"
                                                    />
                                                    : <LazyLoadImage
                                                        src={"/img/ug/header/social-media-icon/share.svg"}
                                                        className="img-responsive"
                                                        alt="share media icon"
                                                    />
                                                }
                                            </div>
                                        </div>
                                        <div onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}>
                                            <div className="header-top-lang">
                                                <div>
                                                    <div>
                                                        <LazyLoadImage
                                                            src={"/img/ug/header/nav-icon/id-circle.png"}
                                                            className="img-responsive"
                                                            alt="id country flag"
                                                        />
                                                    </div>
                                                    <span>INDONESIA</span>
                                                </div>
                                                <div className="second">
                                                    <div>
                                                        <LazyLoadImage
                                                            src={"/img/ug/header/nav-icon/green-dot.png"}
                                                            className="img-responsive"
                                                            alt="id country flag"
                                                        />
                                                    </div>
                                                    <span>{LanguageOption.filter(x => x.prefix === selectedLanguage)[0].name}</span>
                                                </div>
                                            </div>
                                            {showLanguageDropdown && <div className="lang-dropdown">
                                                {countryList.filter(x => isLoggedIn ? x.iso === "ID" : true).map((country, index) => {
                                                    return (
                                                        <div className="header-dropdown-box" key={index}>
                                                            <div className="display-flex">
                                                                <div className="lang-square-flag">
                                                                    <LazyLoadImage
                                                                        src={country.icon_circle}
                                                                        width="30"
                                                                        height="30"
                                                                        alt="country flag"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="lang-country-name">
                                                                    {country.name}
                                                                </div>
                                                                <div className="display-flex">
                                                                    {country.child_languages.map((lang, i) => {
                                                                        return (
                                                                            <div key={i} onClick={() => handleCountryOnClick(country, lang.languageCode)} className={"dropdown-lang" + (selectedLanguageCode.toLowerCase() === lang.languageCode ? " active" : "")} key={i}>
                                                                                {lang.name}
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>}
                                        </div>
                                    </div>
                                    {isLoggedIn ? (
                                        <>
                                            <div className="header-top-second login-now mt-3">
                                                {_userData.isShareHolder && <div onClick={() => {
                                                    beforeEnterVipPage();
                                                }}>
                                                    {t("VIP_EVENT")}
                                                </div>}
                                                <div className="header-vip-dropdown-container" onClick={() => { _history.push(WebUrl._URL_SETTINGS) }} onMouseEnter={() => setIsVIPDropdownOpen(true)} onMouseLeave={() => setIsVIPDropdownOpen(false)}>
                                                    <div className="selection">
                                                        <LazyLoadImage
                                                            src={_userData.isVip ? "/img/ug/header/nav-icon/status_icon/partner.png" : isPlatinum ? "/img/ug/header/nav-icon/status_icon/platinum.png" : "/img/ug/header/nav-icon/status_icon/gold.png"}
                                                            className="img-responsive"
                                                            alt="user icon"
                                                        />
                                                        <div>
                                                            {_userData["username"]}
                                                        </div>
                                                    </div>
                                                    {isVIPDropdownOpen && (<div className="options">
                                                        <div className="options-list">
                                                            <div className="first">
                                                                <div>
                                                                    <LazyLoadImage style={{ width: "70px", height: "45px" }} src={_userData.isVip ? "/img/ug/header/nav-icon/status_icon/partner.svg" : isPlatinum ? "/img/ug/header/nav-icon/status_icon/platinum.svg" : "/img/ug/header/nav-icon/status_icon/gold.svg"} alt="balance" />
                                                                </div>
                                                                <div>
                                                                    <div className="">
                                                                        {_userData["username"]}
                                                                    </div>
                                                                    <div>
                                                                        <div> {t("CURRENT_LEVEL")} {(":")} </div>
                                                                        <div style={{
                                                                            color: _userData.isVip ? "#51A0FF" : isPlatinum ? "#D6E9FF" : "#FDBE2F"
                                                                        }}>{_userData.isVip ? t("PARTNER") : isPlatinum ? t("PLATINUM") : t("GOLD_1")}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="second">
                                                                <div className="progress-bar">
                                                                    <div className="progress-fill" style={{ width: _userData.isVip ? "100%" : isPlatinum ? "66.666%" : "33.333%" }} />
                                                                </div>

                                                                <div className="level-markers">
                                                                    {/* Gold Level */}
                                                                    <div className="level-marker gold">
                                                                        <span style={{ color: "#FDBE2F", fontSize: '12px' }}>{t("GOLD_1")}</span>
                                                                        <div className="">
                                                                            <LazyLoadImage style={{ height: "30px" }} src="/img/ug/header/nav-icon/status_icon/gold.svg" alt="balance" onMouseEnter={() => setIsGoldHover(true)} onMouseLeave={() => setIsGoldHover(false)} />
                                                                        </div>

                                                                    </div>

                                                                    {/* Platinum Level */}
                                                                    <div className="level-marker platinum">
                                                                        <span style={{ color: "#D6E9FF", fontSize: '12px' }}>{t("PLATINUM")}</span>
                                                                        <div className="">
                                                                            <LazyLoadImage style={{ height: "30px" }} src="/img/ug/header/nav-icon/status_icon/platinum.svg" alt="balance" onMouseEnter={() => setIsPlatinumHover(true)} onMouseLeave={() => setIsPlatinumHover(false)} />
                                                                        </div>

                                                                    </div>

                                                                    {/* Partner Level */}
                                                                    <div className="level-marker partner">
                                                                        <span style={{ color: "#51A0FF", fontSize: '12px' }}>{t("PARTNER")}</span>
                                                                        <div className="">
                                                                            <LazyLoadImage style={{ height: "30px" }} src="/img/ug/header/nav-icon/status_icon/partner.svg" alt="balance" onMouseEnter={() => setIsPartnerHover(true)} onMouseLeave={() => setIsPartnerHover(false)} />
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="third">
                                                                <div>
                                                                    {isGoldHover ? t("HOVER_GOLD") : isPlatinumHover ? t("HOVER_PLATIUM") : isPartnerHover ? t("HOVER_PARTNER") : (_userData.isVip ? t("TARGET_PARTNER") : isPlatinum ? t("TARGET_PLATINUM") : t("TARGET_GOLD"))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>)}

                                                </div>
                                                <div onClick={() => {
                                                    _history.push(WebUrl._URL_MEMBER_BENEFIT_PAGE);
                                                }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/memberbenefit.svg"}
                                                        className="img-responsive"
                                                        alt="question i8"
                                                        style={{ width:'30px' }}
                                                    />
                                                </div>
                                                <div onClick={() => {
                                                    _dispatch(setIsShowBigWinning(true));
                                                    updateMemberBigWinningViewHistoryCount();
                                                }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/winning.gif"}
                                                        className="img-responsive"
                                                        alt="question i8"
                                                    />
                                                </div>
                                                <div className="header-mail-icon" onClick={() => { _history.push(WebUrl._URL_NOTIFICATION) }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/notification.svg"}
                                                        className="img-responsive"
                                                        alt="notification icon"
                                                    />
                                                    {unreadNotification > 0 && <div className="header-notification-dot"></div>}
                                                </div>
                                                {showInfoList &&
                                                    <div onClick={() => { _history.push(WebUrl._URL_LIVE_CHAT) }}>
                                                        <LazyLoadImage
                                                            src={"/img/ug/header/nav-icon/live-chat.svg"}
                                                            className="img-responsive"
                                                            alt="live chat"
                                                        />
                                                    </div>
                                                }
                                                {showInfoList &&

                                                    <div onClick={() => { _history.push({ pathname: WebUrl._URL_HOW_TO_PLAY, state: { menuId: 3, slug: "game" } }) }}>


                                                        <LazyLoadImage
                                                            src={"/img/ug/header/nav-icon/how-to-play.svg"}
                                                            className="img-responsive"
                                                            alt="question i8"
                                                        />
                                                    </div>
                                                }

                                                {showInfoList &&
                                                    <div onClick={() => { _history.push({ pathname: WebUrl._URL_FAQ, state: { menuId: 2, slug: "getting-started" } }) }}>
                                                        <LazyLoadImage
                                                            src={"/img/ug/header/nav-icon/help-centre.svg"}
                                                            className="img-responsive"
                                                            alt="notice i8"
                                                        />
                                                    </div>
                                                }

                                                <div onClick={() => { setShowInfoList(!showInfoList) }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/burger.png"}
                                                        className="img-responsive"
                                                        alt="question i8"
                                                    />
                                                </div>
                                                <div className="header-lr-btn-container">
                                                    <button className="custom-register-btn" onClick={() => { _dispatch(performLogout()); _history.replace(WebUrl._URL_MAIN); }}>{t("LOGOUT")}</button>
                                                </div>
                                                {displayOfficialLinks.length > 0 && <div className="header-lr-btn-container">
                                                    <button className="custom-official-link-btn" onClick={() => { setShowOfficialLinkDropdown(!showOfficialLinkDropdown); }}>
                                                      <img src="/img/ug/header/nav-icon/link.svg" alt="official-link" />
                                                      {showOfficialLinkDropdown && 
                                                          <div className="dropdown-wrapper">
                                                              {displayOfficialLinks.map((item, idx) => {
                                                                  return (
                                                                      <div key={idx} className="dropdown-item" onClick={() => { window.location.href = item.link; }}>
                                                                          {item.name.startsWith("OFFICIAL LINK") ? t("OFFICIAL_LINK") + " " + (idx+1) : item.displayText}
                                                                      </div>
                                                                  )
                                                              })}
                                                          </div>
                                                      }
                                                    </button>
                                                </div>}
                                            </div>
                                            <div className="header-show-bottom-online mt-3">
                                                {walletDropdownOptions && walletDropdownOptions.length > 0 &&
                                                    <div className="header-wallet-dropdown-container" onMouseEnter={() => setIsWalletDropdownOpen(true)} onMouseLeave={() => setIsWalletDropdownOpen(false)}>
                                                        <div className="selection">
                                                            <div className="first">
                                                                <LazyLoadImage
                                                                    src={"/img/ug/header/nav-icon/wallet.svg"}
                                                                    className="img-responsive"
                                                                    alt="question i8"
                                                                />
                                                            </div>
                                                            <div className="second">
                                                                {_userData && _userData.walletBalance ? numberWithCurrencyFormat2(_userData.walletBalance, 2, true) : "0.00"}
                                                            </div>
                                                            <div onClick={() => { updateMemberWalletBalance(); setIsWalletDropdownOpen(false); }}>
                                                                <LazyLoadImage
                                                                    src={"/img/ug/header/nav-icon/wallet-refresh.svg"}
                                                                    className="img-responsive"
                                                                    alt="question i8"
                                                                /></div>
                                                            <div className="arrow-container">
                                                                <LazyLoadImage src="/img/ug/header/nav-icon/arrow-down.svg" alt="arrow down" />
                                                            </div>
                                                        </div>
                                                        {isWalletDropdownOpen && (<div className="options">
                                                            {walletDropdownOptions && walletDropdownOptions.length > 0 && walletDropdownOptions.map((option, index) => (
                                                                <div key={index} className="options-list" onClick={() => { _history.push(option.url); }}>
                                                                    <div className="first">
                                                                        <LazyLoadImage src={option.image} alt="balance" />
                                                                    </div>
                                                                    <div className="second">
                                                                        {option.title}
                                                                    </div>
                                                                    <div className="third">
                                                                        {/*<span>{option.value ? isNaN(option.value) ? "0.00" : option.value : <Spinner role="status" size="sm" />}</span>*/}
                                                                        <span>{option.value}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>)}
                                                    </div>
                                                }

                                                {transactionDropdownOptions && transactionDropdownOptions.length > 0 &&
                                                    <div className="header-wallet-dropdown-container" onMouseEnter={() => setIsTransactionDropdownOpen(true)} onMouseLeave={() => setIsTransactionDropdownOpen(false)}>
                                                        <div className="selection">
                                                            <div className="first">
                                                                {t("DEPOSIT")}
                                                            </div>
                                                            <div className="arrow-container">
                                                                <LazyLoadImage src="/img/ug/header/nav-icon/arrow-down.svg" alt="arrow down" />
                                                            </div>
                                                        </div>
                                                        {isTransactionDropdownOpen && (<div className="options">
                                                            {transactionDropdownOptions.filter(j => j.isDisplay).map((option, index) => (
                                                                <div key={index} className="options-list" onClick={() => { _history.push(option.url); }}>
                                                                    <div className="first">
                                                                        <LazyLoadImage src={option.image} alt="balance" />
                                                                    </div>
                                                                    <div className="second">
                                                                        {option.title}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>)}
                                                    </div>
                                                }

                                                <div className="header-wallet" onClick={() => {
                                                    _history.push(WebUrl._URL_MY_PROMO)
                                                }} >
                                                    {/*<div style={{ width: '200px', height: '200px' }}>*/}
                                                    {/*  <Lottie animationData={myPromoAnimation} loop={true} />*/}
                                                    {/*</div>*/}
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/my-promo.svg"}
                                                        className="img-responsive"
                                                        alt="question i8"
                                                        style={{ marginBottom: "4px" }}
                                                    />
                                                    <div>
                                                        {t("MY_PROMO")}
                                                    </div>
                                                </div>

                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="header-top-second mt-3">
                                                <div onClick={() => {
                                                    _dispatch(setIsShowBigWinning(true));
                                                    updateMemberBigWinningViewHistoryCount();
                                                }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/winning.gif"}
                                                        className="img-responsive"
                                                        alt="question i8"
                                                    />
                                                </div>
                                                <div onClick={() => { _history.push({ pathname: WebUrl._URL_HOW_TO_PLAY, state: { menuId: 3, slug: "game" } }) }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/how-to-play.svg"}
                                                        className="img-responsive"
                                                        alt="question i8"
                                                    />
                                                </div>
                                                <div onClick={() => { _history.push({ pathname: WebUrl._URL_FAQ, state: { menuId: 2, slug: "getting-started" } }) }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/help-centre.svg"}
                                                        className="img-responsive"
                                                        alt="notice i8"
                                                    />
                                                </div>
                                                <div onClick={() => { _history.push(WebUrl._URL_LIVE_CHAT) }}>
                                                    <LazyLoadImage
                                                        src={"/img/ug/header/nav-icon/live-chat.svg"}
                                                        className="img-responsive"
                                                        alt="live chat i8"
                                                    />
                                                </div>
                                                <div className="header-lr-btn-container">
                                                    {telegramBotStatus && <button
                                                        className="custom-telegram-btn"
                                                        onClick={() => _dispatch(handleTelegramBannerOnClick())}
                                                    >
                                                        {t("TELEGRAM")}
                                                    </button >}
                                                    <button
                                                        className="custom-login-btn"
                                                        onClick={() => _dispatch(setDisplayLogin(true))}
                                                    >
                                                        {t("LOGIN")}
                                                    </button >
                                                    <button className="custom-register-btn" onClick={() => {
                                                        const code = getHostnameReferralCode(window.location.hostname);
                                                        if (code) {
                                                            window.location.href = `https://${window.location.hostname}/register?code=${code}`;
                                                        }
                                                        else {
                                                            _dispatch(setDisplayRegister(true));
                                                        }
                                                    }}>{t("REGISTER")}</button>
                                                </div>
                                                {displayOfficialLinks.length > 0 && <div className="header-lr-btn-container">
                                                    <button className="custom-official-link-btn" onClick={() => { setShowOfficialLinkDropdown(!showOfficialLinkDropdown); }}>
                                                      <img src="/img/ug/header/nav-icon/link.svg" alt="official-link" />
                                                      {showOfficialLinkDropdown && 
                                                          <div className="dropdown-wrapper">
                                                              {displayOfficialLinks.map((item, idx) => {
                                                                  return (
                                                                      <div key={idx} className="dropdown-item" onClick={() => { window.location.href = item.link; }}>
                                                                          {item.name.startsWith("OFFICIAL LINK") ? t("OFFICIAL_LINK") + " " + (idx+1) : item.displayText}
                                                                      </div>
                                                                  )
                                                              })}
                                                          </div>
                                                      }
                                                    </button>
                                                </div>}
                                            </div>
                                        </>
                                    )}

                                </div>
                            </div>
                            <div className="header-bottom">
                                <div className="header-category-container">
                                    {mergedCategoryList &&
                                        mergedCategoryList.length &&
                                        mergedCategoryList.filter(x => !isLoggedIn ? x.title !== t("DAILY_CHECK_IN") : x).map((item, index) => {
                                            if (item.originalTitle !== null ? (providerList.length > 0 && providerList.filter(x => x.category === item.originalTitle).length > 0) : true) {
                                                return (
                                                    <div key={index} className={index === catIndexClicked ? "focused" : ""} onClick={() => handleHeaderCatOnClick(index)}>
                                                        <div onClick={() => { handleHeaderRoute(item.url, item.openNewWindow) }} className={item.url !== rtpUrl && location.pathname.includes(item.url) ? "header-category-items active" : "header-category-items"} >
                                                            <div className="image">
                                                                <LazyLoadImage
                                                                    src={item.icon}
                                                                    className={"img-responsive header-category-img-icon " + (item.originalTitle === "Togel" ? "togel-icon-resize" : "")}
                                                                    alt={item.title + " i8"}
                                                                />
                                                                {item.isHot && (
                                                                    <>
                                                                        <div className="header-category-tag">
                                                                            <LazyLoadImage
                                                                                src={"/img/ug/header/game-category-icon/hot.svg"}
                                                                                className="img-responsive"
                                                                                alt="hot games i8"
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {item.isNew && (
                                                                    <>
                                                                        <div className="header-category-tag">
                                                                            <LazyLoadImage
                                                                                src={"/img/ug/header/game-category-icon/new.svg"}
                                                                                className="img-responsive"
                                                                                alt="new games i8"
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="header-category-img-title">{item.title}</div>
                                                        </div>
                                                        {item.originalTitle !== null && providerList.length > 0 && providerList.filter(x => (item.originalTitle === 'Slots' || item.originalTitle === 'SlotMix') ? (x.category === 'Slots' || x.category === 'SlotMix') : x.category === item.originalTitle).length > 0 ?
                                                            <div className={"header-provider-dropdown-wrapper" + (isLoggedIn ? " logged-in" : "") + (seletedProvider ? " seletedProvider" : "")}>
                                                                <div className="header-provider-dropdown">
                                                                    {providerList.filter(x => (item.originalTitle === 'Slots' || item.originalTitle === 'SlotMix') ? (x.category === 'Slots' || x.category === 'SlotMix') : x.category === item.originalTitle).map((provider, index) => {
                                                                        return (
                                                                            <div className={"provider-dropdown-wrapper" + (provider.isUM ? " is-um" : "")} key={index} onClick={() => {
                                                                                handleProviderClick(provider);
                                                                            }}>
                                                                                <div className={`dropdown-provider-img ${(isLoggedIn && provider.isUM ? " um" : "")}`}>


                                                                                    <img src={provider.image/*imageMap[provider.name]*/ || defaultImage} alt={provider.name} />
                                                                                    {isLoggedIn && provider.isUM && <div className="um-overlay"></div>}
                                                                                    {isLoggedIn && provider.isUM ?
                                                                                        <img
                                                                                            src={"/img/icon/dashboardv2_um.png"}
                                                                                            className="v2-um-tag-icon"
                                                                                            alt='maintenance-icon'
                                                                                        /> :
                                                                                        provider.productGame != null && provider.productGame["gameCode"] === 'MEGATOGEL' && moment(provider.productGame["parameter_1"]).isValid() && moment(provider.productGame["parameter_1"]).isAfter(moment()) ?
                                                                                            <img
                                                                                                src={"/img/coming-soon.png"}
                                                                                                className="v2-coming-soon-tag-icon"
                                                                                                alt='coming-soon-icon'
                                                                                            /> : null
                                                                                    }
                                                                                </div>
                                                                                <div className="dropdown-provider-name">{provider.name}</div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                            :
                                                            <></>
                                                        }
                                                    </div>
                                                );
                                            }
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </header>
                </div>
            </div>
            <Auth />
            <ShareHolderAuth />
            <NonSeamlessGameWalletModal />
            <DownloadFloatingComponent />
            <ContactUsFloatingComponent />
            <GifFloatingComponent />
            <BigWinningModal />
            {fifaStatus && <WorldCupParlay />}
            {isLoggedIn && <> <CustomMiniGames></CustomMiniGames></>}

        </>

    );
};

export default Header;
